'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var functions = require('@keytrade/functions');
var styled = _interopDefault(require('styled-components'));
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const {
  getFont
} = functions.config.fonts;
const {
  list: colors
} = functions.config.colors;
const boldAllowed = ['md', 'lg'];
const sizesSecure = {
  sm: '1.2rem',
  md: '1.4rem',
  lg: '1.6rem'
};
const sizesPublic = {
  sm: '1.6rem',
  md: '1.8rem',
  lg: '1.8rem'
};
const StyledParagraph = styled.p.withConfig({
  displayName: "Paragraph__StyledParagraph",
  componentId: "sc-1td7sgc-0"
})(["font-family:", ";font-size:", ";line-height:1.5;color:", "};margin:", ";"], props => getFont(props.theme, props.weight), props => props.theme && props.theme.type === 'public' ? sizesPublic[props.size] : sizesSecure[props.size], props => colors[props.color], props => props.margin ? props.margin : '0');
const LoaderWrapper = styled.div.withConfig({
  displayName: "Paragraph__LoaderWrapper",
  componentId: "sc-1td7sgc-1"
})(["margin:", ";position:relative;height:", ";width:5.2rem;"], props => props.margin, props => {
  switch (props.size) {
    case 'sm':
      return '1.6rem';
    case 'md':
      return '1.8rem';
    case 'lg':
      return '2rem';
  }
});
const LoaderLine = styled.div.withConfig({
  displayName: "Paragraph__LoaderLine",
  componentId: "sc-1td7sgc-2"
})(["position:absolute;top:calc(50% - .3rem);left:0;width:1.6rem;height:", ";border-radius:.6rem;background-color:", ";animation:line 2s infinite;@keyframes line{0{width:1.6rem;}25%{width:3.2rem;transform:translateX(0);}50%{width:1.6rem;transform:translateX(1.6rem);}75%{width:3.2rem;transform:translateX(0);}100%{width:1.6rem;transform:translateX(0);}}"], props => {
  switch (props.size) {
    case 'sm':
      return '.4rem';
    case 'md':
      return '.6rem';
    case 'lg':
      return '.8rem';
  }
}, colors.BlueCloudy);
const LoaderDot = styled.div.withConfig({
  displayName: "Paragraph__LoaderDot",
  componentId: "sc-1td7sgc-3"
})(["position:absolute;top:calc(50% - .3rem);display:inline-block;width:", ";height:", ";border-radius:.6rem;background-color:", ";transform:scale(0);animation:dot 1s infinite alternate;@keyframes dot{0{transform:scale(0);}100%{transform:scale(1);}}&:nth-last-child(1){right:0;animation-delay:.5s;}&:nth-last-child(2){right:1rem;}"], props => {
  switch (props.size) {
    case 'sm':
      return '.4rem';
    case 'md':
      return '.6rem';
    case 'lg':
      return '.8rem';
  }
}, props => {
  switch (props.size) {
    case 'sm':
      return '.4rem';
    case 'md':
      return '.6rem';
    case 'lg':
      return '.8rem';
  }
}, colors.BlueCloudy);
const Paragraph = props => {
  return props.isLoading ? /*#__PURE__*/React.createElement(LoaderWrapper, {
    className: props.className,
    size: props.size,
    margin: props.margin
  }, /*#__PURE__*/React.createElement(LoaderLine, {
    size: props.size
  }), /*#__PURE__*/React.createElement(LoaderDot, {
    size: props.size
  }), /*#__PURE__*/React.createElement(LoaderDot, {
    size: props.size
  })) : /*#__PURE__*/React.createElement(StyledParagraph, _extends({
    className: props.className,
    size: props.size,
    weight: props.weight === 'bold' && !boldAllowed.includes(props.size) ? 'regular' : props.weight,
    color: props.color,
    margin: props.margin
  }, props.testId ? {
    'data-testid': props.testId
  } : {}), props.children);
};
Paragraph.defaultProps = {
  size: 'md',
  color: 'BlueDark',
  weight: 'regular'
};
exports.Paragraph = Paragraph;